import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,        // 30s — données considérées fraîches
      gcTime: 5 * 60 * 1000,       // 5min — garbage collection
      refetchOnWindowFocus: true,   // refresh au retour sur l'onglet
      retry: 1,                     // 1 seul retry sur erreur
      refetchOnReconnect: true,
    },
  },
});
